const pisRuns = {
    bindings: {
    },
    templateUrl: '/modules/pis-tool/runs/runs.html',
    controller: 'PisRunsController',
};

angular
    .module('pis-tool.module')
    .component('pisRuns', pisRuns)
    .config(function ($stateProvider) {
        $stateProvider.state('pis.workspaces.runs', {
            url: '/runs',
            views: {
                'pisview@pis': 'pisRuns',
            },
        });
    });
